import React from "react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import microguard from "../assets/gutterguards/microguard.jpeg"
import installation from "../assets/gutterguards/installation.jpg"
import galvanizedguard from "../assets/gutterguards/galvanizedguard.png"
import expanded from "../assets/gutterguards/expanded.jpg"
import downspoutstrainer from "../assets/gutterguards/downspoutstrainer.jpeg"
import guarddiagram from "../assets/gutterguards/guarddiagram.jpeg"
import guarddiagram2 from "../assets/gutterguards/guarddiagram2.jpeg"
import zgutters from "../assets/gutterguards/zgutters.jpg"
import zoom from "../assets/gutterguards/zoom.jpg"
import cloggedSide from "../assets/gutterguards/cloggedSide.jpeg"
import adobeclogged from "../assets/gutterguards/adobeclogged.jpeg"
import chrome from "../assets/gutterguards/chrome.png"
import { BadgePlus, BadgeMinus, MessageSquare } from "lucide-react"
import "./styles/GutterGuards.css"

function GutterGuards() {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  const [activeQuestion, setActiveQuestion] = useState(null)

  const questions = [
    {
      question: "What's the Best Time to Install Gutter Guards?",
      answer:
        "While there's no specific month or season in New York that's ideal for gutter guard installation, it's best to install them when you're also replacing your gutter system to ensure a smooth, cost-effective process. Gutter guards can save you money on future gutter cleaning services, especially if you have deciduous trees.",
    },
    {
      question: "How Effective Are the Majority of Gutter Guards?",
      answer:
        "Based on my two-decade experience as the proprietor of a gutter cleaning enterprise situated in Long Island, NY, and catering to the NY tri-state region, I've observed that many gutter guard systems don't deliver enduring results. Particularly, homes surrounded by certain trees like pines and oaks tend to drop an abundance of debris and organic residues, leading most gutter guards and leaf protectors to need eventual maintenance. Our confidence in our product is such that we offer a guarantee: your gutters will remain clean for at least 10 years, or we'll service them at no charge.",
    },
    {
      question: "What is the Lifespan of Your Gutter Guards?",
      answer:
        "We provide top-notch gutter guards crafted from robust aluminum with micro filtration for unimpeded water flow while blocking debris. These guards are engineered to endure for decades. Unlike many other leaf filtering systems, ours withstand harsh weather and natural elements due to their superior durability. While some systems may claim debris resistance, they often fall short. Manny's gutter guards are designed to channel water into your gutters effectively, preventing overflow that could lead to water spilling over the sides of your home.",
    },
    {
      question: "Do Gutter Guards Perform Well During Heavy Rainfall?",
      answer:
        "While many gutter guard systems struggle during heavy downpours, especially in roof valleys where water accumulates, Manny's gutter guards are designed for effective drainage. They guide water into the gutter while keeping debris out, thanks to the micro openings. These small openings allow rainwater to pass through while blocking debris like roof grit, leaves, twigs, and pine needles, ensuring your gutters remain clear even during heavy rain.",
    },
    {
      question: "Can You Tell Me About Your Warranty?",
      answer:
        "We fully back Manny's Gutter Guards with a 10-year warranty against any manufacturing defects from the installation date. Should the gutter guards suffer damage, dislodgment, or breakage not caused by natural disasters or weather incidents, we'll rectify the issue by reinstalling them. Furthermore, this warranty is transferable.",
    },
    {
      question: "What Are the Cost Savings vs. Yearly Gutter Cleaning?",
      answer:
        "Assuming a Long Island home has around 175-225 linear feet of gutter, and gutter cleaning costs $200 twice a year, gutter guards could save you $400 annually. Over 5 years, that totals $2000 in savings. With three cleanings per year, savings rise to $3000 over 5 years. Averaging these scenarios, you could save around $2500 over 5 years. Subtracting this from the gutter guard installation cost gives your TrueValue™ number, reflecting the adjusted cost of your gutter guard system investment.",
    },
    {
      question: "How is the Cost for Gutter Guard Installation Determined?",
      answer:
        "To provide an accurate cost, we arrange an in-home estimate by contacting us at (123) 456-7890. The cost depends on various factors unique to your home such as its size, the linear footage of gutter guards needed, custom work required, and material costs among others. Our trained professionals will offer a competitive quote, addressing all your inquiries including the savings on future gutter cleaning expenses.",
    },
    {
      question: "Is it Possible to Install Gutter Guards on Existing Gutters?",
      answer:
        "Yes, Manny's leaf guards can be installed over your existing gutters or alongside new 5 or 6-inch seamless gutters. The installation enhances the gutter's security as it's fastened with screws, extending the lifespan of your entire gutter system.",
    },
    {
      question: "Can your Gutter Guards Prevent Ice Dams?",
      answer:
        "No, our gutter guards do not cause ice dams. Ice dams arise from heat escaping the roof and melting snow, which refreezes in the gutter once the heat source is gone. Gutters clogged with debris may contribute to ice dams as water can't drain. Our gutter protection keeps your gutters clear, aiding in the prevention of ice damming.",
    },
  ]

  const renderContent = (
    imgSrc1,
    imgAlt1,
    imgSrc2,
    imgAlt2,
    imgSrc3,
    imgAlt3,
    headerText,
    paragraphs
  ) => {
    return (
      <div className="guards-content">
        <div className="guards-images">
          <img src={imgSrc1} alt={imgAlt1} className="guard-image" />
          <img src={imgSrc2} alt={imgAlt2} className="guard-image" />
          <img src={imgSrc3} alt={imgAlt3} className="guard-image" />
        </div>
        <div className="guards-text">
          <h2>{headerText}</h2>
          {paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="guards-container">
      <div className="guards-title">Gutter Guards</div>
      {renderContent(
        zgutters,
        "guardless gutters with leaves inside",
        microguard,
        "gutter with guard overlooking roof",
        null,
        null,
        <span>
          <span className="blue-text">Gutter Guard</span> Installation Service
        </span>,
        [
          "When it comes to Long Island’s finest gutter guards, look no further than Manny’s Seamless Gutters, Inc. Many homeowners seek a long-term solution to their gutter issues, and Manny’s Seamless Gutters, Inc. provides top-notch gutter protection solutions. We offer a range of products designed to keep your gutters and downspouts clear of debris and blockages.",
          "Our installed gutter guards effectively prevent large debris from adhering to the gutter screens while efficiently channeling water into the gutters. The design includes raised, stepped grooves to prevent water from splashing back beneath the roof shingles.",
        ]
      )}

      {renderContent(
        chrome,
        "isolated installed gutter guard in gutter",
        cloggedSide,
        "leaves stopped from entering gutter by guard",
        adobeclogged,
        "hands in clogged gutter",
        <span>
          <span className="blue-text">Aluminum Gutter Guard</span>
        </span>,
        [
          "While there’s no such thing as completely maintenance-free gutters, gutter guards are a wise investment because they help maintain clean and unobstructed rain gutters.",
          "At Manny's Seamless Gutters, Inc., we offer a variety of proven products that safeguard your gutters, preventing debris from entering and causing blockages. Reach out to us today for a free quote. Call (123) 456-7890 or click here.",
        ]
      )}

      {renderContent(
        galvanizedguard,
        "leaves stopped from entering gutter by guard",
        null,
        null,
        null,
        null,
        <span>
          <span className="blue-text">Aluminum Screens</span>
        </span>,
        [
          "Our rust-resistant screens, often referred to as gutter guards or leaf guards, securely snap onto your existing gutter’s outer lip and arch over, resting atop the edge of your asphalt roof. Debris that falls from the roof collects where the screen meets the roof.",
          "When rainwater flows down the shingles, it travels over and through the collected debris, straining down through the screen. While these screens can’t keep everything out, they effectively block most debris. They can extend the time between average gutter cleanings by six months to a full year, depending on the number of surrounding trees.",
        ]
      )}
      {renderContent(
        zoom,
        "enlarged view of gutter guard",
        downspoutstrainer,
        "mushroom metal strainer for downspout",
        null,
        null,
        <span>
          <span className="blue-text">How Do Gutter Guards</span> Get Installed?
        </span>,
        [
          "If you're wondering about the installation of gutter guards on Long Island, it’s essential to know that many large gutter guard companies do not directly employ their own installers. Instead, they often subcontract local gutter companies for installation. However, at Manny’s Seamless Gutters, Inc., we employ our installers and gutter cleaning technicians. Our experienced and supervised technicians install gutter guards directly into the fascia board and your existing gutter system, enhancing structural strength and ensuring long-lasting performance.",
          "Next, we have the Downspout Strainer, which is mushroom-shaped and placed on top of the downspout to prevent debris from entering.",
        ]
      )}

      {renderContent(
        guarddiagram2,
        "gutter diagram with guard 2",
        expanded,
        "overhead view of gutter with guard",
        installation,
        "gutter guard installation on gutter",
        <span>
          <span className="blue-text">BENEFITS</span> of Installing Our Gutter
          Guards
        </span>,
        [
          <div className="line-container">
            <span className="blue-text">Prevent Clogs: </span>
            <span>
              "Gutter guards act as a barrier, preventing leaves, debris, and
              twigs from entering your gutters. This significantly reduces the
              chances of clogs forming."
            </span>
          </div>,
          <div className="line-container">
            <span className="blue-text">Reduce Maintenance:</span>
            <span>
              "With gutter guards in place, you will need to clean your gutters
              less frequently. This can save you time, money, and the hassle of
              climbing ladders to clean out debris."
            </span>
          </div>,
          <div className="line-container">
            <span className="blue-text">Extend Gutter Lifespan:</span>
            <span>
              "Gutter guards help protect your gutters from the weight of debris
              and standing water, which can lead to sagging or damage. This
              extends the lifespan of your gutter system."
            </span>
          </div>,
          <div className="line-container">
            <span className="blue-text">Prevent Water Damage:</span>
            <span>
              "Clogged gutters can cause water to overflow and damage your
              home&rsquo;s foundation, siding, and landscaping. Gutter guards
              keep water flowing properly, preventing costly water damage."
            </span>
          </div>,
          <div className="line-container">
            <span className="blue-text">Prevent Pest Infestations:</span>
            <span>
              "Clogged gutters can become attractive nesting sites for birds,
              insects, and rodents. Gutter guards deter pests from making a home
              in your gutters."
            </span>
          </div>,
          <div className="line-container">
            <span className="blue-text">Prevent Ice Dams:</span>
            <span>
              "In cold climates, clogged gutters can lead to ice dams, which can
              damage your roof and create leaks. Gutter guards help maintain
              proper water flow, reducing the risk of ice dams."
            </span>
          </div>,
        ]
      )}

      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
      {renderContent(
        guarddiagram,
        "gutter guard diagram",
        null,
        null,
        null,
        null,
        <span>
          <span className="blue-text">Gutter Guard</span> Installation Service
        </span>,
        [
          "When it comes to Long Island’s finest gutter guards, look no further than Manny’s Seamless Gutters, Inc. Many homeowners seek a long-term solution to their gutter issues, and Manny’s Seamless Gutters, Inc. provides top-notch gutter protection solutions. We offer a range of products designed to keep your gutters and downspouts clear of debris and blockages.",
          "Our installed gutter guards effectively prevent large debris from adhering to the gutter screens while efficiently channeling water into the gutters. The design includes raised, stepped grooves to prevent water from splashing back beneath the roof shingles.",
        ]
      )}

      {/* Include FAQ content here */}

      {/* Add any other sections and content as needed */}
      <div className="reachout">
        <h2>
          <span className="blue-text">Manny&rsquo;s Gutter Guards</span>
        </h2>
        <p>
          Contact Manny&apos;s Seamless Gutters, Inc. today for all your gutter
          needs. We provide worry-free systems to keep your gutters clean and
          your home protected from rainwater damage.
        </p>

        <p>
          Gutter cleaning can be a thing of the past with our reliable gutter
          guard solutions. Call us at (123) 456-7890 for an in-home estimate and
          discover how much you can save by avoiding future gutter cleaning
          costs.
        </p>
      </div>

      <h2 className="blue-text">
        Commonly Asked Questions About Gutter Guards
      </h2>
      <div className="gutter-guards-faq">
        {questions.map((q, index) => (
          <div
            className={`question-wrapper ${
              activeQuestion === index ? "active" : ""
            }`}
            key={index}
          >
            <div
              className="question"
              onClick={() =>
                setActiveQuestion(index === activeQuestion ? null : index)
              }
            >
              {activeQuestion === index ? (
                <>
                  <BadgeMinus size={34} /> {q.question}
                </>
              ) : (
                <>
                  <BadgePlus size={34} /> {q.question}
                </>
              )}
            </div>
            {activeQuestion === index && (
              <div className="answer">{q.answer}</div>
            )}
          </div>
        ))}
      </div>
      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
    </div>
  )
}

export default GutterGuards
